<template>
  <BaseBoxColor variant="gray" class="w-full p-4">
    <div class="flex items-center gap-x-4">
      <h3>{{ name }}</h3>
    </div>
    <GridRow class="mt-2">
      <GridCol :span-md="12" class="flex flex-row space-y-4">
        <div class="flex flex-row gap-8">
          <div>
            <h4 class="text-sm uppercase text-white/75">
              {{ $t("type") }}
            </h4>
            <BaseBadge
              class="bg-opacity-70"
              >{{ getChannelTypeById(ChannelTypeId).name }}</BaseBadge
            >
          </div>
          <div v-if="Scopes.length">
            <h4 class="text-sm uppercase text-white/75">
              {{ $t("scopes") }}
            </h4>
            <div class="flex items-center gap-2">
              <strong class="flex gap-x-2">
                {{ Scopes.length }}
              </strong>
              <span v-if="Scopes.length" @click="openModal(Scopes)" class=" cursor-pointer expand material-symbols-rounded text-primary">visibility</span>
            </div>
          </div>
        </div>
      </GridCol>
      <GridCol :span-md="12" class="flex flex-col space-y-4">
        <StandardChart v-if="chartOptions" class="h-[12.5rem] w-full" :options="chartOptions" />
      </GridCol>
    </GridRow>
  </BaseBoxColor>
</template>

<script setup>
import { h, ref, markRaw, onMounted } from "vue"
import { StatisticsService } from "@/api/services";
import useChannelTypeStore from "@/stores/channelType"
import useModalStore from "@/stores/modal";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const chartOptions = ref()

const props = defineProps({
  id: Number,
  name: String,
  ChannelTypeId: Number,
  enabled: Boolean,
  Scopes: {
    type: Array,
    default: () => [],
  },
});

const modal = useModalStore();
const { getChannelTypeById } = useChannelTypeStore()

//For inline render component h() see https://vuejs.org/guide/extras/render-function
const openModal = (passedScopes) => {
  if(passedScopes.length){
    modal.openModal({
      title: t("scopeList"),
      component: markRaw({
        setup () {
          const vnode = h(
            'div',
            { id: 'scopeModal', class: 'h-[15vh] overflow-y-auto'},
            [
              h(
                'ul',
                [
                  passedScopes.map((scope) => h(
                    'li',
                    [
                      `${ scope.prefix }/${ scope.slug }`
                    ]
                  ))
                ]
              )
            ]
          )
          return () => vnode
        }
      })
    });
  }
}

onMounted(async () => {
  try{
    let tempStats = await StatisticsService.getStatistics("channel", props.id);
    chartOptions.value = tempStats.data.jsConfig
  } catch (e) {
    console.error(e)
  }
})
</script>
